const topicItems = [
  { name: '明星恋情', heat: '286万讨论', trend: 'up', icon: 'ri-heart-line' },
  { name: '综艺名场面', heat: '213万讨论', trend: 'up', icon: 'ri-emotion-laugh-line' },
  { name: '热播剧结局', heat: '198万讨论', trend: 'hot', icon: 'ri-tv-line' },
  { name: '偶像新歌', heat: '175万讨论', trend: 'up', icon: 'ri-music-line' },
  { name: '时尚红毯', heat: '152万讨论', trend: 'up', icon: 'ri-vip-crown-line' },
  { name: '直播翻车', heat: '138万讨论', trend: 'new', icon: 'ri-live-line' },
  { name: '选秀黑马', heat: '126万讨论', trend: 'up', icon: 'ri-star-line' },
  { name: '绯闻辟谣', heat: '115万讨论', trend: 'hot', icon: 'ri-alert-line' },
  { name: '影视路透', heat: '98万讨论', trend: 'new', icon: 'ri-camera-line' },
  { name: '网红八卦', heat: '87万讨论', trend: 'up', icon: 'ri-user-smile-line' },
  { name: '体育娱乐', heat: '76万讨论', trend: 'new', icon: 'ri-basketball-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            当前最受关注的吃瓜话题，看看大家在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-3 bg-background-100 border border-background-200/60 rounded-lg px-4 py-3 transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer"
            >
              <div className="w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center flex-shrink-0">
                <i className={`${topic.icon} text-primary-500 text-sm`}></i>
              </div>
              <div className="flex flex-col min-w-0">
                <span className="text-sm font-bold text-foreground-800 whitespace-nowrap">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {topic.heat}
                </span>
              </div>
              {topic.trend === 'hot' && (
                <span className="flex-shrink-0 inline-block px-1.5 py-0.5 text-[10px] font-bold bg-accent-100 text-accent-600 rounded whitespace-nowrap">
                  HOT
                </span>
              )}
              {topic.trend === 'new' && (
                <span className="flex-shrink-0 inline-block px-1.5 py-0.5 text-[10px] font-bold bg-primary-100 text-primary-600 rounded whitespace-nowrap">
                  NEW
                </span>
              )}
              {topic.trend === 'up' && (
                <span className="flex-shrink-0">
                  <i className="ri-arrow-up-line text-accent-500 text-xs font-bold"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}